<template>
  <section class="section--press-logos">
    <div class="container">
      <div class="press-logos">
        <div class="press-logo-wrapper press-logo-wrapper--label">
          <small>AS FEATURED IN</small>
        </div>

        <div class="press-logo-wrapper">
          <img
            alt="The Information logo"
            src="https://assets.kinside.com/static/web/static_pages/press/press-the-information-logo.png"
            class="press-logo"
          />
        </div>

        <div class="press-logo-wrapper">
          <img
            alt="Fortune logo"
            src="https://assets.kinside.com/static/web/static_pages/press/press-fortune-logo.png"
            class="press-logo"
          />
        </div>

        <div class="press-logo-wrapper">
          <img
            alt="Inc. logo"
            src="https://assets.kinside.com/static/web/static_pages/press/press-inc.png"
            class="press-logo press-logo--inc"
          />
        </div>

        <div class="press-logo-wrapper">
          <img
            alt="Business Insider logo"
            src="https://assets.kinside.com/static/web/static_pages/press/press-business-insider-logo.png"
            class="press-logo press-logo--business-insider"
          />
        </div>

        <div class="press-logo-wrapper">
          <img
            alt="Forbes logo"
            src="https://assets.kinside.com/static/web/static_pages/press/press-forbes-logo.png"
            class="press-logo press-logo--forbes"
          />
        </div>

        <div class="press-logo-wrapper">
          <img
            alt="TechCrunch logo"
            src="https://assets.kinside.com/static/web/static_pages/press/press-tech-crunch-logo.png"
            class="press-logo"
          />
        </div>

        <div class="press-logo-wrapper">
          <img
            alt="EBN logo"
            src="https://assets.kinside.com/static/web/static_pages/press/press-ebn.png"
            class="press-logo press-logo--ebn"
          />
        </div>

        <div class="press-logo-wrapper">
          <img
            alt="Reuters logo"
            src="https://assets.kinside.com/static/web/static_pages/press/press-reuters-logo.png"
            class="press-logo press-logo--reuters"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'press-logos',
};
</script>

<style lang="scss" scoped>
.section--press-logos {
  background-color: var(--sapphire-50);
  border-top: 1px solid white;
  overflow: hidden;
}

.press-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.press-logo-wrapper {
  padding: 15px 18px 16px;

  &--label {
    min-width: 125px;
    color: var(--gray-400);
    padding-right: 8px;
  }
}

.press-logo {
  opacity: 0.5;
  height: 23px;

  &--techcrunch {
    opacity: 0.4;
  }

  &--reuters {
    opacity: 0.75;
  }

  &--ebn {
    opacity: 0.35;
  }

  &--inc {
    opacity: 0.25;
  }

  &--business-insider {
    opacity: 0.7;
  }
}
</style>
